<template>
  <button
    v-if="userRole !== 'marketer' && userRole !== 'price_editor'"
    :disabled="!isFilterSelect"
    @click="resetFilters"
    class="reset-filters"
  >
    <svg
      class="reset-filters__icon"
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.17 3.91C20.1063 3.78712 20.0102 3.68399 19.8921 3.61173C19.774 3.53947 19.6384 3.50084 19.5 3.5H12.5C12.3011 3.5 12.1103 3.57902 11.9697 3.71967C11.829 3.86032 11.75 4.05109 11.75 4.25C11.75 4.44891 11.829 4.63968 11.9697 4.78033C12.1103 4.92098 12.3011 5 12.5 5H18L16.15 7.56C16.0333 7.71913 15.9846 7.9181 16.0146 8.11314C16.0446 8.30818 16.1509 8.4833 16.31 8.6C16.4691 8.7167 16.6681 8.7654 16.8631 8.73539C17.0582 8.70538 17.2333 8.59913 17.35 8.44L20.1 4.69C20.1846 4.58007 20.2361 4.44832 20.2484 4.31018C20.2608 4.17204 20.2336 4.03323 20.17 3.91Z"
        fill="#ffffff"
      />
      <path
        d="M8.65 3.72005C8.65 3.72005 8.65 3.72005 8.6 3.72005C8.54296 3.67085 8.47893 3.63041 8.41 3.60005C8.33943 3.57294 8.26534 3.5561 8.19 3.55005H4.5C4.36157 3.55089 4.226 3.58952 4.10792 3.66178C3.98984 3.73404 3.89375 3.83717 3.83 3.96005C3.76636 4.08328 3.73915 4.22209 3.75155 4.36023C3.76395 4.49837 3.81544 4.63011 3.9 4.74005L9.25 12V19.75C9.25259 19.9482 9.33244 20.1374 9.47253 20.2775C9.61263 20.4176 9.80189 20.4975 10 20.5H14C14.1981 20.4975 14.3874 20.4176 14.5275 20.2775C14.6676 20.1374 14.7474 19.9482 14.75 19.75V12L14.81 11.91L18.47 15.53C18.5392 15.6002 18.6218 15.6557 18.7128 15.6935C18.8038 15.7313 18.9015 15.7505 19 15.75C19.0986 15.7511 19.1964 15.7321 19.2875 15.6943C19.3786 15.6565 19.4611 15.6006 19.53 15.53C19.6704 15.3894 19.7493 15.1988 19.7493 15C19.7493 14.8013 19.6704 14.6107 19.53 14.47L8.65 3.72005ZM13.4 11.31C13.302 11.4357 13.2492 11.5907 13.25 11.75V19H10.75V11.75C10.7508 11.5907 10.698 11.4357 10.6 11.31L6 5.00005H7.82L13.73 10.85L13.4 11.31Z"
        fill="#ffffff"
      />
    </svg>
  </button>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ResetFiltersButton",
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },

    isFilterSelect() {
      const filters = this.$store.getters["ordersModule/getFilters"];
      const scope = this.$store.getters["ordersModule/getScope"];
      const sort = this.$store.getters["ordersModule/getIsSorted"];
      const search = this.$store.getters["ordersModule/getSearchQuery"];
      return !!(filters.length || scope.length || sort || search.length);
    },
    ...mapState({
      // scope
      scope: state => state.ordersModule.scope,
    }),
  },
  methods: {
    resetFilters() {
      this.$store.commit("ordersModule/setScope", "");
      this.$store.commit("filtersModule/setSortType", null);
      this.$store.commit("filtersModule/setSortValue", null);
      // icons

      this.$store.commit("filtersModule/setSortedFlag", null);
      this.$store.commit("ordersModule/setSearchQuery", "");
      this.$store.commit("ordersModule/setCurrentPage", 1);
      localStorage.removeItem("sortType");
      localStorage.removeItem("sortValue");
      localStorage.removeItem("isSortedFlag");
      localStorage.removeItem("filtersToSpecialist");

      //   refactor
      this.$store.commit("ordersModule/setCurrentPage", 1);
      this.$store.commit("ordersModule/setPerPage", 15);
      this.$store.commit("ordersModule/clearFilters");
      this.$store.commit("ordersModule/setSearchQuery", "");
      this.$store.dispatch("ordersModule/getOrders");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/mixins/flex.scss";
@import "@/styles/mixins/media.scss";
@import "@/styles/mixins/px-to-rem.scss";
@import "@/styles/UI/buttons.scss";
.reset-filters {
  @extend .button-main;
  color: #ffffff;
  height: rem(38);
  width: rem(38);
  padding: 0;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__icon {
    pointer-events: none;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
